import { useTranslation } from 'react-i18next';
import Button from '../../../../../../common/widgets/Button';
import Dialog from '../../../../../../common/widgets/Dialog';
import Icons from '../../../../../../common/widgets/Icons';
import { resources } from '../../../../resources/resources';

interface CnpGdprDialogProps {
  closeDialog: () => void;
}

export const CnpGdprDialog = (props: CnpGdprDialogProps) => {
  const { closeDialog } = props;
  const { t: translate } = useTranslation();

  return (
    <Dialog
      closeDialog={closeDialog}
      showCloseIcon
      closeOnClickOutside
      className="dialog-xxxl"
    >
      <div className="dialog-content">
        <div
          className="dialog-title"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <h2 style={{ display: 'flex', alignItems: 'center' }}>
            <Icons.MessageQuestion />
            <span style={{ marginLeft: '10px' }}>
              {translate(resources.invoicingAddress.dialog.cnpGdprTitle)}
            </span>
          </h2>
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: translate(resources.invoicingAddress.dialog.cnpGdpr),
          }}
        />
      </div>
      <div className="dialog-actions vertical">
        <Button onClick={() => closeDialog()} className="btn btn-solid">
          <span className="btn-text"> {translate(resources.understood)}</span>
        </Button>
      </div>
    </Dialog>
  );
};
